import type { GenericServerError } from '../types/apiTypes';

/**
 * Convert string error message to standard server error object.
 */
export const normalizeError = (error: GenericServerError | string): GenericServerError => {
  return typeof error === 'string' ? { code: '', details: [], message: error, target: '' } : error;
};
